module.exports = __webpack_public_path__ + "static/media/elm-gray.acdc86e8.png";